import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon } from "lucide-react";

interface SalesKPICardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  subtitle?: string;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  borderColor?: string;
}

export default function SalesKPICard({ 
  title, 
  value, 
  icon: Icon, 
  subtitle,
  trend,
  borderColor = "border-l-primary"
}: SalesKPICardProps) {
  return (
    <Card className={`border-l-4 ${borderColor}`}>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">
          {value}
        </div>
        {subtitle && (
          <p className="text-xs text-muted-foreground mt-2 flex items-center">
            <Icon className="h-4 w-4 ml-1" />
            {subtitle}
          </p>
        )}
        {trend && (
          <p className={`text-xs mt-2 flex items-center ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`}>
            {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
          </p>
        )}
      </CardContent>
    </Card>
  );
}
